var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppViewport',{staticClass:"App",attrs:{"background":_vm.theme.windowBackground,"viewport-background":_vm.theme.background,"transition-name":_vm.transitionName}},[_c('router-view',{key:_vm.$route.path,staticClass:"view"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }